export default __webpack_public_path__ + "static/media/Guitars_04.0004a688.png";